<script setup>
import { computed } from 'vue';
import '../../../../../public/fonts/contact-icons/contact-icons.css';

const props = defineProps({
  icon: {
    type: String,
    required: true,
    validator: value =>
      [
        'contact-outline',
        'contact-filled',
        'megaphone-outline',
        'megaphone-filled',
        'collapse-right',
        'collapse-left',
        'collapse-top',
        'collapse-bottom',
        'inbox-outline',
        'inbox-filled',
        'calendar-outline',
        'calendar-filled',
        'workflow-outline',
        'workflow-filled',
        'analytics-outline',
        'analytics-filled',
        'dashboard-outline',
        'dashboard-filled',
        'organization-outline',
        'organization-filled',
        'search-outline',
        'search-filled',
        'help-outline',
        'help-filled',
        'notification-outline',
        'notification-filled',
        'tag-outline',
        'tag-filled',
        'timer-outline',
        'timer-filled',
        'alarm-outline',
        'alarm-filled',
        'settings-outline',
        'settings-filled',
        'x',
        'circle-x',
        'maximize',
        'minimize',
        'undo',
        'redo',
        'plus',
        'minus',
        'position',
        'thumbs-up-outline',
        'thumbs-down-outline',
        'thumbs-up-filled',
        'thumbs-down-filled',
        'happy-outline',
        'happy-filled',
        'plus-circle-outline',
        'plus-circle-filled',
        'refresh-outline',
        'refresh-filled',
        'lightning-outline',
        'lightning-filled',
        'webhook-outline',
        'webhook-filled',
        'send-horizontal-outline',
        'send-horizontal-filled',
        'square-x',
        'at',
        'microphone-outline',
        'microphone-filled',
        'attachment-outline',
        'attachment-filled',
        'chevron-left',
        'chevron-right',
        'chevron-up',
        'chevron-down',
        'label-2-outline',
        'label-2-filled',
        'sticker-open',
        'sticker-outline',
        'sticker-filled',
        'link',
        'reply',
        'note-outline',
        'note-filled',
        'copy-outline',
        'copy-filled',
        'admin',
        'admin-filled',
        'calendar-add-outline',
        'calendar-add-filled',
        'info',
        'info-filled',
        'delete',
        'delete-outline',
        'delete-filled',
        'user-circle-outline',
        'user-circle-filled',
        'logout',
        'logout-outline',
        'logout-filled',
        'store-outline',
        'store-filled',
        'tick',
        'tick-double',
        'tick-single',
        'circle-check-outline',
        'circle-check-filled',
        'chat-outline',
        'chat-filled',
        'comment-2-outline',
        'comment-2-filled',
        'summarize-outline',
        'summarize-filled',
        'user-add-outline',
        'user-add-filled',
        'user-x-outline',
        'user-x-filled',
        'unassigned-outline',
        'unassigned-filled',
        'files-outline',
        'files-filled',
        'credit-card-outline',
        'credit-card-filled',
        'lock-outline',
        'lock-filled',
        'new-office-outline',
        'new-office-filled',
        'ai-outline',
        'ai-filled',
        'teams-outline',
        'teams-filled',
        'user-group-outline',
        'user-group-filled',
        'collaboration-outline',
        'collaboration-filled',
        'pencil-edit-outline',
        'pencil-edit-filled',
        'external-link-outline',
        'external-link-filled',
        'channels-outline',
        'channels-filled',
        'integration-outline',
        'integration-filled',
        'whatsapp-business-outline',
        'whatsapp-business-filled',
        'messenger-outline',
        'messenger-filled',
        'instagram-outline',
        'instagram-filled',
        'more-horizontal',
        'more-vertical',
        'lifecycle-outline',
        'lifecycle-filled',
        'invoice-outline',
        'invoice-filled',
        'snippet-outline',
        'snippet-filled',
      ].includes(value),
  },
  strokeWidth: {
    type: Number,
    default: 1.5,
    validator: value => [1, 1.25, 1.5, 1.75, 2].includes(value),
  },
  size: {
    type: Number,
    default: null,
  },
});

const strokeClasses = {
  1: '!font-[100]',
  1.25: '!font-[125]',
  1.5: '!font-[150]',
  1.75: '!font-[175]',
  2: '!font-[200]',
};

const strokeClass = computed(() => strokeClasses[props.strokeWidth]);
const sizeClasses = {
  12: 'text-xs',
  14: 'text-sm',
  16: 'text-base',
  18: 'text-[18px]',
  20: 'text-xl',
  22: 'text-[22px]',
  24: 'text-2xl',
  26: 'text-[26px]',
  28: 'text-[28px]',
  32: 'text-[32px]',
};
const sizeClass = computed(() => sizeClasses[props.size]);
</script>

<template>
  <span
    class="ci"
    :class="[`ci-${icon}`, strokeClass, sizeClass]"
    aria-hidden="true"
  />
</template>
